/** Bloco de adicionais de UM sabor (chamado #262): o passo pai e a opção dele vêm sempre juntos. */
export function ehBlocoDeAdicionais(
  passo: { idProdutoPassoPai?: number | null; idItemPai?: number | null },
): passo is { idProdutoPassoPai: number; idItemPai: number } {
  return typeof passo.idProdutoPassoPai === 'number' && typeof passo.idItemPai === 'number'
}
